import { render, staticRenderFns } from "./PatientHistoryItemMedication.vue?vue&type=template&id=4c240e6b&scoped=true&lang=pug&"
import script from "./PatientHistoryItemMedication.vue?vue&type=script&lang=js&"
export * from "./PatientHistoryItemMedication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c240e6b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
